<template>

  <b-container>
    <b-row class="d-flex flex-row justify-content-center mt-5 mb-5">
      <b-col class="text-center d-flex flex-column align-items-center ">

        <b-button class="see-more animation-shadow stand-up-animation">
          <slot></slot>
        </b-button>

      </b-col>
    </b-row>
  </b-container>

</template>

<script>
export default {
  name: "Bt5",
}
</script>

<style scoped>
.see-more {
  background-color: var(--primary);
  font-weight: bold;
  color: var(--dark) !important;
  font-size: 22px;
  padding: 20px 40px 20px;
  transition: all ease-in-out .3s;
  border: none !important;
}
.see-more:hover {
  background: var(--light-secondary) !important;
  color: white !important;
}

.stand-up-animation {
  transform: translateY(0px);
  transition: all 0.3s ease 0s;
}

.stand-up-animation:hover {

  color: #fff;
  transform: translateY(-7px);
  transition: all 0.3s ease 0s;
}

.animation-shadow:hover {
  box-shadow: 10px 10px 10px rgba(180, 210, 198, 0.4);
}
</style>